import React, { memo } from "react";
import {Box, TextField, Typography} from "@mui/material";
import {Stack} from "@mui/system";

interface Props {
    title?: string;
    size?: "small" | "medium";
    variant?: "outlined" | "filled" | "standard";
    name: string;
    value?: string;
    defaultValue?: string;
    required?: boolean;
    disabled?: boolean;
    bgColor?: string;
    onChange: (value: string) => void;
}

function HourMinuteInputFields(
    {
        title,
        size,
        variant,
        name,
        value,
        defaultValue,
        required,
        disabled,
        bgColor,
        onChange
    }: Props) {

    const handleHourValueUpdated = (event: React.ChangeEvent<HTMLInputElement>) => {
        const hourValue = event.target.value;
        const minuteValue = (value?.split(':')[1]) || '0';
    
        const newHourValue = hourValue.replace(/^0+/, "") || '0';
    
        const formattedHour = (newHourValue === '0' && minuteValue === '0') ? '0' : newHourValue;
        const formattedMinute = (newHourValue === '0' && minuteValue === '0') ? '0' : minuteValue;
    
        onChange(`${formattedHour}:${formattedMinute}`);
    };

    const handleMinuteValueUpdated = (event: React.ChangeEvent<HTMLInputElement>) => {
        const minuteValue = event.target.value;
        const hourValue = (value?.split(':')[0]) || '0';
    
        const newMinuteValue = minuteValue.replace(/^0+/, "") || '0';
    
        const formattedHour = (newMinuteValue === '0' && hourValue === '0') ? '0' : hourValue;
        const formattedMinute = (newMinuteValue === '0' && hourValue === '0') ? '0' : newMinuteValue;
    
        onChange(`${formattedHour}:${formattedMinute}`);
    };
    
    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <Stack direction="row" spacing={2} sx={{
                alignItems: "center"
            }}>
                <Typography variant="body2" gutterBottom>
                    Time(r)
                </Typography>
                <TextField
                    required={required}
                    name={name}
                    type={"number"}
                    variant={variant ? variant : "outlined"}
                    size={size}
                    defaultValue={defaultValue}
                    value={value?.split(':')[0] || '0'}
                    onChange={handleHourValueUpdated}
                    fullWidth
                    disabled={disabled}
                    slotProps={{
                        input: {
                            inputProps: { min: 0, max: 24 },
                            sx: {
                                fontSize: 'body2.fontSize',
                                backgroundColor: bgColor ? bgColor : 'background.paper',
                            },
                        }
                    }}
                />
                
                <Typography variant="body2" gutterBottom>
                    Minutt(er)
                </Typography>
                <TextField
                    required={required}
                    name={name}
                    variant={variant ? variant : "outlined"}
                    size={size}
                    type={"number"}
                    defaultValue={defaultValue}
                    value={value?.split(':')[1] || '0'}
                    onChange={handleMinuteValueUpdated}
                    fullWidth
                    disabled={disabled}
                    slotProps={{
                        input: {
                            inputProps: { min: 0, max: 59 },
                            sx: {
                                fontSize: 'body2.fontSize',
                                backgroundColor: bgColor ? bgColor : 'background.paper',
                            },
                        }
                    }}
                />
            </Stack>
        </Box>
    );
}

export default memo(HourMinuteInputFields);
